import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Hammer, LayoutDashboard, Plus, Folders, CheckCircle2, FileText, Receipt, ListTodo } from "lucide-react";

const navItems = [
  { to: "/", label: "Pulpit", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/zlecenia/nowe", label: "Nowe zlecenie", icon: Plus, testid: "nav-new-order" },
  { to: "/zlecenia", label: "Zlecenia", icon: Folders, testid: "nav-orders" },
  { to: "/zakonczone", label: "Zakończone", icon: CheckCircle2, testid: "nav-completed" },
  { to: "/wyceny", label: "Wyceny", icon: FileText, testid: "nav-quotes" },
  { to: "/koszty", label: "Koszty", icon: Receipt, testid: "nav-costs" },
  { to: "/zadania", label: "Zadania", icon: ListTodo, testid: "nav-tasks" },
];

export default function Layout({ children }) {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-layout">
      <header
        className="border-b border-[var(--border)] bg-[var(--surface)] sticky top-0 z-30"
        data-testid="app-header"
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-8">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            data-testid="brand-link"
          >
            <span className="w-9 h-9 rounded-md bg-[var(--primary)] text-white flex items-center justify-center group-hover:bg-[var(--primary-hover)] transition-colors">
              <Hammer size={18} />
            </span>
            <div className="leading-tight">
              <div className="heading text-base font-semibold tracking-tight">
                Stolarnia Pro
              </div>
              <div className="text-xs text-[var(--text-muted)]">
                Zarządzanie zleceniami
              </div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1 ml-4" data-testid="main-nav">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  data-testid={item.testid}
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium flex items-center gap-2 transition-colors ${
                      isActive
                        ? "bg-[var(--surface-2)] text-[var(--primary)]"
                        : "text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--surface-2)]/60"
                    }`
                  }
                >
                  <Icon size={16} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>
        </div>
        {/* Mobile nav */}
        <div className="md:hidden border-t border-[var(--border)] overflow-x-auto" data-testid="mobile-nav">
          <div className="flex px-2 py-2 gap-1 min-w-max">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active =
                item.end
                  ? location.pathname === item.to
                  : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`${item.testid}-mobile`}
                  className={`px-3 py-1.5 rounded-md text-sm flex items-center gap-1.5 whitespace-nowrap ${
                    active
                      ? "bg-[var(--surface-2)] text-[var(--primary)]"
                      : "text-[var(--text-muted)]"
                  }`}
                >
                  <Icon size={14} />
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-6 py-8" data-testid="page-content">
        {children}
      </main>
      <footer className="border-t border-[var(--border)] py-6 text-center text-xs text-[var(--text-muted)]">
        Stolarnia Pro — narzędzie do zarządzania meblami na wymiar
      </footer>
    </div>
  );
}
